module.exports = "/images/vendor/svg-country-flags/svg/tr.svg?69a0293b2c67b5b1cd2fee10843e6cd8";